export const getShootingImages = () => {
  const images = [];

  for (let i = 0; i < 10; i++) {
    images.push(`/assets/images/shooting/${i + 1}.webp`);
  }

  return images;
};
